import { SalesTaxFilingStatusEnum } from '@prisma/client';

import { IIndirectTaxFilingsV2ListParams } from './types';
import { useIndirectTaxFilingV2StatusCount } from './useIndirectTaxFilingV2StatusCount';

export type IIndirectTaxFilingV2StatusCounts = Record<
  SalesTaxFilingStatusEnum,
  number
>;

type StatusCountsParams = Omit<
  IIndirectTaxFilingsV2ListParams,
  'filingStatuses' | 'cursor' | 'limit'
>;

// The main list supplies the ALL total via its own response, so we only need
// the five per-status buckets here.

export function useIndirectTaxFilingV2StatusCounts(
  params: StatusCountsParams | null
): {
  counts: IIndirectTaxFilingV2StatusCounts;
  isLoading: boolean;
  error: unknown;
} {
  const scheduled = useIndirectTaxFilingV2StatusCount(
    SalesTaxFilingStatusEnum.SCHEDULED,
    params
  );
  const accruing = useIndirectTaxFilingV2StatusCount(
    SalesTaxFilingStatusEnum.ACCRUING,
    params
  );
  const active = useIndirectTaxFilingV2StatusCount(
    SalesTaxFilingStatusEnum.ACTIVE,
    params
  );
  const filed = useIndirectTaxFilingV2StatusCount(
    SalesTaxFilingStatusEnum.FILED,
    params
  );
  const overdue = useIndirectTaxFilingV2StatusCount(
    SalesTaxFilingStatusEnum.OVERDUE,
    params
  );

  const error =
    scheduled.error ??
    accruing.error ??
    active.error ??
    filed.error ??
    overdue.error ??
    null;

  return {
    counts: {
      [SalesTaxFilingStatusEnum.SCHEDULED]: scheduled.count,
      [SalesTaxFilingStatusEnum.ACCRUING]: accruing.count,
      [SalesTaxFilingStatusEnum.ACTIVE]: active.count,
      [SalesTaxFilingStatusEnum.FILED]: filed.count,
      [SalesTaxFilingStatusEnum.OVERDUE]: overdue.count,
    },
    isLoading:
      scheduled.isLoading ||
      accruing.isLoading ||
      active.isLoading ||
      filed.isLoading ||
      overdue.isLoading,
    error,
  };
}
